import { createRouter, createWebHistory } from "vue-router"
import { useAuthStore } from '@/stores/auth.js'

import NotFound from '@/pages/NotFound.vue'
import Guest from '@/layouts/Guest.vue'
import Register from '@/pages/auth/Register.vue'
import Login from '@/pages/auth/Login.vue'
import TwoFactorChallenge from '@/pages/auth/TwoFactorChallenge.vue'
import ForgotPassword from '@/pages/auth/ForgotPassword.vue'
import ResetPassword from '@/pages/auth/ResetPassword.vue'
import VerifyEmail from '@/pages/auth/VerifyEmail.vue'

import Authenticated from '@/layouts/Authenticated.vue'
import ConfirmPassword from '@/pages/auth/ConfirmPassword.vue'
import User from '@/pages/User.vue'
import SmmNetworks from '@/pages/smm/Networks.vue'
import SmmNetworkDetail from '@/pages/smm/NetworkDetail.vue'
import SmmSchedule from '@/pages/smm/Schedule.vue'
import SmmMedia from '@/pages/smm/Media.vue'
import SmmKanban from '@/pages/smm/Kanban.vue'
import SmmBoard from '@/pages/smm/Board.vue'
import SmmSettings from '@/pages/smm/Settings.vue'
import SmmMarketingPlans from '@/pages/smm/MarketingPlans.vue'
import SmmToday from '@/pages/smm/Today.vue'
import SmmLogs from '@/pages/smm/Logs.vue'
import SmmStats from '@/pages/smm/Stats.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: Authenticated,
      meta: { requiresAuth: true },
      children: [
        { path: '/', name: 'SmmContent', component: SmmMedia, alias: ['/smm/content'] },
        { path: '/smm', redirect: { name: 'SmmContent' } },
        { path: '/smm/networks', name: 'SmmNetworks', component: SmmNetworks },
        { path: '/smm/networks/:id', name: 'SmmNetworkDetail', component: SmmNetworkDetail },
        { path: '/smm/schedule', name: 'SmmSchedule', component: SmmSchedule },
        { path: '/smm/media', redirect: { name: 'SmmContent' } },
        { path: '/smm/kanban', name: 'SmmKanban', component: SmmKanban },
        { path: '/smm/board', name: 'SmmBoard', component: SmmBoard },
        { path: '/smm/marketing-plans', name: 'SmmMarketingPlans', component: SmmMarketingPlans },
        { path: '/smm/today', name: 'SmmToday', component: SmmToday },
        { path: '/smm/stats', name: 'SmmStats', component: SmmStats },
        { path: '/smm/settings', redirect: { name: 'SmmSettingsChannels' } },
        { path: '/smm/settings/channels', name: 'SmmSettingsChannels', component: SmmSettings },
        { path: '/smm/settings/prompts', name: 'SmmSettingsPrompts', component: SmmSettings },
        { path: '/smm/settings/campaigns', name: 'SmmSettingsCampaigns', component: SmmSettings },
        { path: '/smm/settings/platforms', name: 'SmmSettingsPlatforms', component: SmmSettings },
        { path: '/smm/settings/business', name: 'SmmSettingsBusiness', component: SmmSettings },
        { path: '/smm/settings/board', name: 'SmmSettingsBoard', component: SmmSettings },
        { path: '/smm/settings/logs', name: 'SmmSettingsLogs', component: SmmLogs },
        { path: '/seo', redirect: { name: 'SmmContent' } },
        { path: '/user', name: 'User', component: User },
        { path: '/confirm-password', name: 'ConfirmPassword', component: ConfirmPassword },
      ]
    },
    {
      path: '/auth',
      redirect: '/login',
      component: Guest,
      meta: { isGuest: true },
      children: [
        { path: '/register', name: 'Register', component: Register },
        { path: '/login', name: 'Login', component: Login },
        { path: '/verify-email', name: 'VerifyEmail', component: VerifyEmail },
        { path: '/two-factor-challenge', name: 'TwoFactorChallenge', component: TwoFactorChallenge },
        { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
        { path: '/reset-password/:token', name: 'ResetPassword', component: ResetPassword }
      ]
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: NotFound,
    }
  ],
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth && !authStore.currentUser) {
    next({ name: 'Login' })
  } else if (to.meta.isGuest && authStore.currentUser) {
    next({ name: 'SmmContent' })
  } else {
    next();
  }
});

export default router;
